import { CloseOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Button, Flex, Form, Input, message, Upload, UploadProps } from 'antd';
import { useContext, useEffect, useState } from 'react';

import { SmxInspectorContext } from '../inspector-provider';
import { ViewerWrapperModalAppryze } from '../viewer-wrapper-modal-appryze';

const { Dragger } = Upload;

export const FieldUploadFile = () => {
    const form = Form.useFormInstance();

    const { errorInfo, setErrorInfo } = useContext(SmxInspectorContext);
    const [file, setFile] = useState<File | string | null>(null);

    useEffect(() => {
        if (!file) {
            form.setFieldsValue({
                file: null,
            });
        } else {
            setErrorInfo?.({
                ...errorInfo,
                errorFields: errorInfo?.errorFields?.filter((field: any) => !field.name.includes('file')),
            });
        }
    }, [file]);

    const props: UploadProps = {
        name: 'file',
        multiple: true,
        maxCount: 1,
        accept: 'application/pdf',
        showUploadList: false,
        beforeUpload: () => false,
        // customRequest,
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                setFile(info.file as unknown as File);
                form.setFieldsValue({
                    fileName: info.file.name,
                });
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    const hasError = errorInfo?.errorFields?.filter(
        (field: any) => field.name.includes('file') && field.errors.length,
    ).length;

    return (
        <>
            <Form.Item
                name="file"
                label="File"
                rules={[{ required: true, message: 'Upload file' }]}
                getValueProps={(value) => ({ fileList: value ? [value] : [] })}
            >
                <Dragger {...props} style={hasError ? { border: '1px solid red' } : {}}>
                    {!file ? (
                        <Flex vertical align={'center'} style={{ padding: '40px 0' }}>
                            <p className="ant-upload-drag-icon">
                                <FilePdfOutlined style={{ fontSize: 40 }} />
                            </p>
                            <p className="ant-upload-text" style={{ fontSize: 14 }}>
                                <span style={{ color: '#1677ff' }}>Upload a file</span>, drag and drop
                            </p>
                            <p className="ant-upload-hint">PDF type only</p>
                        </Flex>
                    ) : (
                        <>
                            <Button
                                onClick={() => {
                                    setFile(null);
                                }}
                                type="text"
                                variant={'filled'}
                                icon={<CloseOutlined />}
                                style={{
                                    position: 'absolute',
                                    zIndex: 1000,
                                    top: 0,
                                    right: 0,
                                }}
                            />
                            <ViewerWrapperModalAppryze file={file} />
                        </>
                    )}
                </Dragger>
            </Form.Item>
            <Form.Item name="fileName" label="File Name" rules={[{ required: true, message: 'Fill out file name' }]}>
                <Input style={{ width: '100%' }} disabled />
            </Form.Item>
        </>
    );
};
